import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BasketDiscountType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { Typography } from 'common/typography';
import { useCampaignModuleContext } from 'modules/campaigns/context';

import { DiscountAmountLabel } from './DiscountAmountLabel';
import CampaignFormItem from '../CampaignFormItem';

export type DiscountAmountDetailsProps = {
  discountType: BasketDiscountType;
  discountAmount: number;
  minBasketSize: number;
  action?: React.ReactNode;
  'data-testid'?: string;
};

export const DiscountAmountDetails = ({
  discountAmount,
  minBasketSize,
  action,
  discountType,
  ...props
}: DiscountAmountDetailsProps) => {
  const { currency } = useCampaignModuleContext();

  return (
    <CampaignFormItem
      data-testid={props['data-testid']}
      action={action}
      title={<FormattedMessage id="campaigns.discount-amount.section-title" />}
      value={
        <Typography.Body3>
          {minBasketSize === 0 ? (
            <FormattedMessage
              id="campaigns.discount-amount.section-details-no-basket"
              values={{
                discountValue: (
                  <Typography.Body3 fontWeight="semiBold">
                    <DiscountAmountLabel discountAmount={discountAmount} discountType={discountType} />
                  </Typography.Body3>
                ),
              }}
            />
          ) : (
            <FormattedMessage
              id="campaigns.discount-amount.section-details"
              values={{
                discountValue: (
                  <Typography.Body3 fontWeight="semiBold">
                    <DiscountAmountLabel discountAmount={discountAmount} discountType={discountType} />
                  </Typography.Body3>
                ),
                minBasketSize: (
                  <Typography.Body3 fontWeight="semiBold">
                    <MonetaryAmount amount={minBasketSize} currency={currency} />
                  </Typography.Body3>
                ),
              }}
            />
          )}
        </Typography.Body3>
      }
    />
  );
};
